import { receivingSubmitRequestComponent } from './submitRequest.component';
import { receivingStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const receivingSubmitRequestStateName = `${receivingStateName}.submitRequest`;

export const receivingSubmitRequestState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingSubmitRequestStateName,
    url: '/request/submit/:ticketId',
    component: receivingSubmitRequestComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket(),
      stateIndex: (receivingService) => {
        'ngInject';
        return receivingService.states.length - 1;
      }
    }
  });
};
